import React, { useMemo, useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
// @ts-ignore
import TextBox from "../../common/TextBox";
// @ts-ignore
import SelectBox from "../../common/SelectBox/SelectBox";
import { STORE_SERVICE_LABELS, FULFILLMENT_DROPDOWN_OPTIONS, FULFILLMENT_SYSTEM_DROPDOWN_OPTIONS, STORE_SERVICE_BUTTON_LABELS } from "../../common/App/app-constant";
// @ts-ignore
import PrimaryButton from "../PrimaryButton/PrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import { saveServiceTypeConfiguration } from "../../CreatePOS/redux/posSlice";
import { isArrayValid } from "../../../utils/DataUtils";
// @ts-ignore
import { ViewBasicDetailNameAndValue } from "../../CompleteSetup/CompleteSetupViewUtils";
import OverlayLoader from "../../common/Loader/OverlayLoader";
import { Typography } from "@material-ui/core";

interface FulfillmentSectionProps {
  details?: {
    billingPos: string;
    fulfilledBy: string;
    deliveredBy: string;
    fulfillmentSystem: string;
  };
  handleChange?: (event: any) => void;
  errors?: {
    billingPos?: string;
    fulfilledBy?: string;
    deliveredBy?: string;
    fulfillmentSystem?: string;
  };
  disabled?: boolean;
  handleSave?: () => void;
  isReadOnly?: boolean;
  posDetails?: {
    posNo?: string | number;
    serviceType?: Array<{
        serviceTypeId: string | number;
        billingPos?: string;
        fulfilledBy?: string;
        deliveredBy?: string;
        fulfillmentSystem?: string;
    }>
  };
  serviceTypeId: string | number;
  classes?: any;
}

const FulfillmentSection: React.FC<FulfillmentSectionProps> = ({ handleChange, errors, disabled, handleSave, isReadOnly, posDetails, serviceTypeId, classes }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: any) => state.pos);

  const [formData, setFormData] = useState({
      billingPos: "",
      fulfilledBy: "",
      deliveredBy: "",
      fulfillmentSystem: ""
  });

  const currentServiceDetails = useMemo(() => {    
    const service = isArrayValid(posDetails?.serviceType)
      ? posDetails?.serviceType?.find((s) => s?.serviceTypeId?.toString() === serviceTypeId?.toString())
      : null;

    if (!service) return {};

    const { billingPos, fulfilledBy, deliveredBy, fulfillmentSystem } = service;
    const extractedDetails: any = {};
    if (billingPos) extractedDetails.billingPos = billingPos;
    if (fulfilledBy) extractedDetails.fulfilledBy = fulfilledBy;
    if (deliveredBy) extractedDetails.deliveredBy = deliveredBy;
    if (fulfillmentSystem) extractedDetails.fulfillmentSystem = fulfillmentSystem;

    return extractedDetails;
  }, [posDetails, serviceTypeId]);

  useEffect(() => {
    if (Object.keys(currentServiceDetails).length > 0) {
        setFormData({
            billingPos: currentServiceDetails.billingPos || "",
            fulfilledBy: currentServiceDetails.fulfilledBy || "",
            deliveredBy: currentServiceDetails.deliveredBy || "",
            fulfillmentSystem: currentServiceDetails.fulfillmentSystem || ""
        });
    }
  }, [currentServiceDetails]);

  const handleFormChange = (event: any) => {
    const { name, value } = event.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (handleChange) {
        handleChange(event);
    }
  };

  const onSave = () => {
    if (handleSave) {
      handleSave();
    } else {
        const payload = {
            serviceTypeId: serviceTypeId,
            billingPos: formData.billingPos,
            deliveredBy: formData.deliveredBy,
            fulfilledBy: formData.fulfilledBy,
            fulfillmentSystem: formData.fulfillmentSystem,
        };
        if (posDetails?.posNo) {
            // @ts-ignore
            dispatch(saveServiceTypeConfiguration({ posNo: posDetails.posNo, data: payload }));
        }
        
    }
  };

  if (isReadOnly) {
     if (!currentServiceDetails || Object.keys(currentServiceDetails).length === 0) {
      return null;
    }
    return (
      <Grid container alignItems="center" className={classes.gridContainer}>
        <Typography className={classes.sectionTitle}>{STORE_SERVICE_LABELS.SERVICE_DETAILS}</Typography>
        <Grid container alignItems="center">
          <ViewBasicDetailNameAndValue classes={classes} xsValue={3} fieldTitle={STORE_SERVICE_LABELS.BILLING_POS} fieldData={currentServiceDetails?.billingPos} />
          <ViewBasicDetailNameAndValue classes={classes} xsValue={3} fieldTitle={STORE_SERVICE_LABELS.FULFILLED_BY} fieldData={currentServiceDetails?.fulfilledBy} />
          <ViewBasicDetailNameAndValue classes={classes} xsValue={3} fieldTitle={STORE_SERVICE_LABELS.DELIVERED_BY} fieldData={currentServiceDetails?.deliveredBy} />
          <ViewBasicDetailNameAndValue classes={classes} xsValue={3} fieldTitle={STORE_SERVICE_LABELS.FULFILLMENT_SYSTEM} fieldData={currentServiceDetails?.fulfillmentSystem} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={1}>
        <OverlayLoader loading={loading} />
        <Grid item xs={12} sm={6} md={3}>
            <TextBox
                label={STORE_SERVICE_LABELS.BILLING_POS}
                name="billingPos"
                value={formData.billingPos}
                handleChange={handleFormChange}
                error={!!errors?.billingPos}
                helperText={errors?.billingPos}
                textBoxId="billingPos"
                disabled={disabled}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
            <SelectBox
                label={STORE_SERVICE_LABELS.FULFILLED_BY}
                name="fulfilledBy"
                value={formData.fulfilledBy}
                handleChange={handleFormChange}
                menuItems={FULFILLMENT_DROPDOWN_OPTIONS}
                error={!!errors?.fulfilledBy}
                disabled={disabled}
                isClearable={true}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
            <SelectBox
                label={STORE_SERVICE_LABELS.DELIVERED_BY}
                name="deliveredBy"
                value={formData.deliveredBy}
                handleChange={handleFormChange}
                menuItems={FULFILLMENT_DROPDOWN_OPTIONS}
                error={!!errors?.deliveredBy}
                disabled={disabled}
                isClearable={true}
            />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
             <SelectBox
                label={STORE_SERVICE_LABELS.FULFILLMENT_SYSTEM}
                name="fulfillmentSystem"
                value={formData.fulfillmentSystem}
                handleChange={handleFormChange}
                menuItems={FULFILLMENT_SYSTEM_DROPDOWN_OPTIONS}
                error={!!errors?.fulfillmentSystem}
                disabled={disabled}
                isClearable={true}
            />
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="flex-end">
            <PrimaryButton buttonLabel={Object.keys(currentServiceDetails).length > 0 ? STORE_SERVICE_BUTTON_LABELS.UPDATE : "Save"} onClick={onSave} />
          </Grid>
        </Grid>
    </Grid>
  );
};

export default FulfillmentSection;
